var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.118 30.305v-11.106c0-5.459-1.129-9.6-7.529-9.6-3.012 0-5.082 1.694-6.023 3.2v-2.635h-6.024v20.329h6.212v-9.976c0-2.635 0.565-5.271 3.765-5.271s3.2 3.012 3.2 5.271v9.788h6.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.377 10.164h6.212v20.33h-6.212v-20.329z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.576 0c-2.071 0-3.576 1.694-3.576 3.576s1.694 3.765 3.576 3.765c1.882 0 3.577-1.694 3.577-3.765 0-1.882-1.694-3.576-3.577-3.576z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.287a31689276eaf17e347c57cd08259c.svg";
export { ForwardRef as ReactComponent };